import styles from "./ListItem.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type ListItemProps = {
  label: string | React.ReactElement;
  description?: string;
  trailingIcon?: React.ReactElement;
  onClick?: () => void;
  className?: string;
  showTopBorder?: boolean;
  showBottomBorder?: boolean;
  leadingIcon?: React.ReactElement;
  isOffer?: boolean;
};

export const ListItem = ({
  label,
  description,
  trailingIcon,
  onClick,
  showTopBorder = true,
  showBottomBorder = true,
  className,
  leadingIcon,
  isOffer = false,
}: ListItemProps) => {
  const buttonClassNames = cx(styles.listItemButton, className, {
    topBorder: showTopBorder,
    bottomBorder: showBottomBorder,
    isOffer: isOffer,
    nonInteractive: !onClick,
  });

  const labelClassNames = cx(styles.listItemButton__label, {
    listItemButton__labelString: typeof label === "string",
  });

  return (
    <button
      type="button"
      className={buttonClassNames}
      onClick={onClick}
      data-testid="listItem:button"
    >
      {leadingIcon ? (
        <div
          className={styles.listItemButton__leadingIcon}
          data-testid="listItem:leadingIcon"
        >
          {leadingIcon}
        </div>
      ) : null}
      <div className={styles.listItemButton__textGroup}>
        <div className={labelClassNames} data-testid="listItem:label">
          {label}
        </div>
        {description ? (
          <div
            className={styles.listItemButton__description}
            data-testid="listItem:description"
          >
            {description}
          </div>
        ) : null}
      </div>
      <div
        className={styles.listItemButton__trailingIcon}
        data-testid="listItem:trailingIcon"
      >
        {trailingIcon}
      </div>
    </button>
  );
};
